import { array, date, number, object, string } from 'yup';
import { translateAndCastToString } from '../../../../utils';

export const newDeliveryListValidationSchema = [
    object()
        .shape({
            invoiceNumber: string()
                .min(2, translateAndCastToString('Invoice number is too short'))
                .max(50, translateAndCastToString('Invoice number is too long'))
                .optional(),
            deliveryDateUtc: date()
                .min(new Date(), translateAndCastToString(`Delivery date can't be in past`))
                .required(),
            supplierId: string()
                .required(translateAndCastToString('Supplier is a required field'))
        }),
    object()
        .shape({
            deliveryListItems: array()
                .of(object(
                    {
                        priceWithoutVat: number()
                            .min(0, translateAndCastToString('Must be positive number'))
                            .required(),
                        totalCost: number()
                            .min(0, translateAndCastToString('Must be positive number'))
                            .required(),
                        quantity: number()
                            .moreThan(0, translateAndCastToString('Must be greater than 0'))
                            .required(),
                    }
                ).required())
                .min(0)
                .required()
        })
];

export const verifyDeliveryListValidationSchema = [
    object()
        .shape({
            invoiceNumber: string()
                .min(2, translateAndCastToString('Invoice number is too short'))
                .max(50, translateAndCastToString('Invoice number is too long'))
                .optional(),
            deliveryDateUtc: date()
                .min(new Date(), translateAndCastToString(`Delivery date can't be in past`))
                .required(),
            supplierId: string()
                .required(translateAndCastToString('Supplier is a required field'))
        }),
    object()
        .shape({
            pendingListItems: array()
                .of(object(
                    {
                        unitPriceWithoutVat: number()
                            .min(0, translateAndCastToString('Price must be greater than 0'))
                            .required(translateAndCastToString('Price is a required field')),
                        unitPrice: number()
                            .min(0, translateAndCastToString('Price must be greater than 0'))
                            .required(translateAndCastToString('Price is a required field')),
                        quantity: number()
                            .moreThan(0, translateAndCastToString('Quantity must be greater than 0'))
                            .required(translateAndCastToString('Quantity is a required field')),
                        finalAmount: number()
                            .moreThan(0, translateAndCastToString('Final amount must be greater than 0'))
                            .required(translateAndCastToString('Final amount is a required field')),
                        unitOfMeasure: string()
                            .nullable()
                            .required(translateAndCastToString('Must have a unit')),
                        stockCard: object()
                            .nullable()
                            .required(translateAndCastToString('Must be attached to a stock card'))
                    }
                ).required())
                .min(0)
                .required()
        })
];
